import { Suspense, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import Loading from 'components/global/Loading';
import AppLayout from 'components/layout/AppLayout/AppLayout';

import useAccessControl from 'hooks/useAccessControl';
import useLocale from 'hooks/useLocale';

import ErrorPage from 'pages/Errors/ErrorPage';
import PagesErrorBoundary from 'pages/Errors/PagesErrorBoundry';
import PermissionDenied from 'pages/Errors/PermissionDenied';

import UserService from 'utils/UserService';
import PATHS from 'utils/paths';

import ModalRoutes from './ModalRoutes';

const ProtectedRoutes = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const isUserAuthenticated = !!localStorage.getItem('ACCESS_TOKEN');
	const { LangCountryCode } = useLocale();

	useEffect(() => {
		if (!isUserAuthenticated) {
			navigate(`${PATHS.LOGIN}/${LangCountryCode}`, {
				state: {
					redirectTo: location
				}
			});
		}
	}, []);

	return (
		isUserAuthenticated && (
			<UserService>
				<Pages>
					<Outlet />
				</Pages>
			</UserService>
		)
	);
};

const Pages = (props) => {
	const { pathname } = useLocation();
	const checkRole = useAccessControl();
	const isAuthorized = checkRole(pathname);
	const errorPage = pathname === PATHS.ERROR;

	return isAuthorized ? (
		<AppLayout>
			<PagesErrorBoundary>
				<ModalRoutes />
				{/* this suspense is required for lazy loading of routes */}
				<Suspense fallback={<Loading />}>{props.children}</Suspense>
			</PagesErrorBoundary>
		</AppLayout>
	) : (
		<>{errorPage ? <ErrorPage /> : <PermissionDenied />}</>
	);
};

export default ProtectedRoutes;
